import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-devicepos-admin',
  templateUrl: './devicepos-admin.component.html',
  styleUrls: ['./devicepos-admin.component.css']
})
export class DeviceposAdminComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
